var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row mt-3" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "icon-toggle" }, [
        _c(
          "div",
          {
            staticClass: "dot cursor-pointer green",
            on: {
              click: function($event) {
                _vm.extraExpanded = !_vm.extraExpanded
              }
            }
          },
          [
            _c("em", {
              staticClass: "title-icon",
              class: _vm.getIcon(_vm.extraExpanded)
            })
          ]
        ),
        _c("span", { staticClass: "dot-title" }, [
          _vm._v("Información del PEI")
        ])
      ])
    ]),
    _vm.extraExpanded
      ? _c("div", { staticClass: "col-md-12 mt-2" }, [
          _c(
            "div",
            { staticClass: "box-container" },
            _vm._l(_vm.value, function(item, index) {
              return _c(
                "div",
                { key: "pei-info" + index, staticClass: "row p-3" },
                [
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("custom-balloon", {
                        staticClass: "mt-1",
                        attrs: {
                          "background-color": "green",
                          text: item.statusName
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col pl-5" }, [
                    _c(
                      "div",
                      {
                        staticClass: "color-gray-6 font-14 font-weight-normal"
                      },
                      [_vm._v("Fecha:")]
                    ),
                    _c(
                      "div",
                      { staticClass: "font-weight-normal text-black" },
                      [_vm._v(" " + _vm._s(_vm._f("date")(item.date)) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "div",
                      {
                        staticClass: "color-gray-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Número de PEI: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "font-weight-normal text-black" },
                      [_vm._v(" " + _vm._s(item.peiNumber) + " ")]
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c("action-button", {
                        staticClass: "mr-n3",
                        attrs: {
                          i: "fas fa-file-search",
                          text: "Ver Documentos",
                          variant:
                            "outline-success transparent-color bg-transparent"
                        },
                        on: {
                          click: function($event) {
                            return _vm.viewDocument(item)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  index != _vm.value.length - 1
                    ? _c("div", { staticClass: "col-12 separator-line-2 mt-4" })
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }